export const PUBLIC_API_ORIGIN = 'https://api.liquidspirit.org';

const LOCAL_API_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const isLocalApiUrl = (value) => {
  if (typeof value !== 'string' || !value.trim()) return false;

  try {
    const parsed = new URL(value.trim(), 'http://localhost');
    return LOCAL_API_HOSTS.has(parsed.hostname);
  } catch {
    return false;
  }
};

export const resolveApiBaseUrl = ({
  apiUrl = import.meta.env.VITE_API_URL,
  isProd = import.meta.env.PROD,
} = {}) => {
  const trimmed = typeof apiUrl === 'string' ? apiUrl.trim() : '';

  if (isProd && (!trimmed || isLocalApiUrl(trimmed))) {
    return PUBLIC_API_ORIGIN;
  }

  return trimmed;
};

export const API_BASE_URL = resolveApiBaseUrl();

